import React from 'react';
import formatDate from 'date-fns/format';
import { useTranslation } from 'react-i18next';

export interface QlfDateProps {
  date: string | Date;
}

export function QlfDate({ date }: QlfDateProps) {
  const { t } = useTranslation();
  const dateFormat = t('dateFormat') ?? 'dd/MM/yyyy';
  const formattedDate = formatDate(typeof date === 'string' ? new Date(date) : date, dateFormat);
  return <>{formattedDate}</>;
}
